<template>
  <div class="test">
    <template v-if="show">
      <div>
        <div class="title">检验报告</div>
        <div class="info">
          <p class="title">{{ info.name || '' }}</p>
          <div class="list">
            <div v-if="info.patientName">就诊人：{{ info.patientName }}</div>
            <div v-if="info.bizNo">申请单号：{{ info.bizNo }}</div>
            <div v-if="info.bizTypeName">类型：{{ info.bizTypeName }}报告</div>
            <div v-if="info.checkPart">检查部位：{{ info.checkPart }}</div>
            <div v-if="info.deptName">科室名称：{{ info.deptName }}</div>
            <div v-if="info.applyDoctorName">
              送检医生：{{ info.applyDoctorName }}
            </div>
            <div class="over" v-if="info.reportTime">
              报告时间:{{ info.reportTime | calcTime }}
            </div>
            <div class="over">申请时间：{{ info.reqTime | calcTime }}</div>
          </div>
        </div>

        <div class="more_box" v-if="info.lczd">
          <div class="title">临床诊断</div>
          <div class="list-box">
            <p style="padding-bottom: 10px">{{ info.lczd }}</p>
          </div>
        </div>

        <div class="more_box" v-if="info.result">
          <div class="title">结论</div>
          <div class="list-box">
            {{ info.result }}
          </div>
        </div>
      </div>

      <div class="more_box" style="margin-bottom: 20px">
        <div class="title">检查所见</div>
        <div class="table">
          <div class="table-head">
            <p>检查项目</p>
            <p>结果值</p>
            <p>参考值</p>
            <p>单位</p>
          </div>
          <div v-for="(i, index) in info.reportItems" :key="index">
            <p>{{ i.itemName }}</p>
            <p>
              {{ i.itemValue }}
              <span style="color: #ee0a24" v-if="i.result == 'H'">↓</span>
              <span style="color: #ee0a24" v-if="i.result == 'L'">↑</span>
            </p>
            <p>{{ i.refer }}</p>
            <p>{{ i.unit || '无' }}</p>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <noData>暂无数据</noData>
    </template>
  </div>
</template>

<script>
import { getTest } from '@/api/report'
import noData from '@/components/NoData'
export default {
  components: {
    noData,
  },
  data() {
    return {
      info: {},
      show: false,
    }
  },
  created() {
    this.form = this.$route.query
    this.init()
  },
  methods: {
    async init() {
      getTest(this.form)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.checkItems && res.data.checkItems.length > 0) {
              res.data.checkItems.forEach((i) => {
                for (let name in i) {
                  if (i[name] && this.delSpace(i[name])) {
                    i[name] = null
                  }
                }
              })
            }
            this.info = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.show = true
        })
    },
  },
}
</script>

<style lang="less">
.test {
  padding: 10px;
  p {
    margin: 0;
  }
  > div > .title {
    font-size: 25px;
    font-weight: 800;
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
  }
  .info {
    margin-top: 15px;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.3);
    border-radius: 20px;
    .title {
      font-weight: 800;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px solid #ccc;
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      div {
        width: 40%;
        font-size: 14px;
        padding: 10px 0 5px;
      }
      .over {
        width: 100%;
      }
    }
  }
  .more_box {
    margin-top: 15px;
    background: #ffffff;
    overflow: hidden;
    // border: 1px solid #ccc;
    box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.3);
    border-radius: 20px;
    .title {
      min-width: 20%;
      margin: 25px 0 10px;
      font-size: 16px;
      display: inline-block;
      padding: 10px;
      padding-right: 100px;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      background: #5383f9;
      color: #fff;
    }
    .list-box {
      padding: 10px 20px;
      font-size: 16px;
      span {
        font-weight: 800;
      }
    }
    .table {
      font-size: 16px;
      padding: 10px;
      > div {
        display: flex;
        align-items: center;
        padding: 10px 0;
        &:nth-of-type(even) {
          background: #e6f3f9;
        }
        p {
          flex: 1;
          text-align: center;
        }
      }
      .table-head {
        margin-top: 10px;
        background: #5383f9;
        color: #fff;
      }
    }
  }
}
</style>
